import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { LetDirective } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';
import {
  DashboardTypes,
  InstallationDetailsStore,
  InstallationFeaturesStore,
  RichDevice,
} from '@store';
import {
  FeatureNames,
  FeaturePropertyKey,
} from '@vi-iot/client/apis/operational-data/operational-data.constants';
import {
  DeviceNameCommands,
  DeviceNameProperties,
  Feature,
} from '@vi-iot/client/apis/operational-data/operational-data.model';
import { DeviceRoles } from '@vi-iot/client/models';
import { Observable, Subject, takeUntil } from 'rxjs';
import { BrandLogo } from 'src/app/+installations/helpers/brand-logo';
import { ValueStrategyModule } from 'src/app/operational-data-common/feature-pipes/value-strategy-based/value-strategy-module';

@Component({
  selector: 'app-dry-contact-devices-header-tile',
  templateUrl: './dry-contact-devices-header-tile.component.html',
  styleUrls: ['./dry-contact-devices-header-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatIcon, ValueStrategyModule, LetDirective, TranslateModule],
})
export class DryContactDevicesHeaderTileComponent implements OnInit {
  @Input() device: RichDevice;
  dashboardTypes = DashboardTypes;
  gatewaySerial: string;
  gatewayHasDevices: boolean;
  imageUri: string;
  brandLogo: string;
  deviceNumber: number;
  isHeatpump: boolean;

  deviceName$: Observable<Feature<DeviceNameProperties, DeviceNameCommands>>;

  readonly featurePropertyKey = FeaturePropertyKey;
  private ngUnsubscribe$ = new Subject<void>();

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private installationDetailsStore: InstallationDetailsStore,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.gatewaySerial = params?.gatewaySerial;
    });

    this.deviceName$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceName,
      this.device.id
    );

    this.installationDetailsStore
      .selectGatewayHasDevices(this.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((gatewayHasDevices) => {
        this.gatewayHasDevices = gatewayHasDevices;
      });

    this.imageUri = this.getImageUri(this.device);
    this.brandLogo = BrandLogo.getBrandLogo(this.device.roles);
    this.deviceNumber = Number(this.device.id.split('-').pop() ?? 0);
    this.isHeatpump = this.isDryContactHeatpump();
  }

  isDryContactHeatpump(): boolean {
    return (
      this.device.roles?.includes(DeviceRoles.InterfaceDryContact) &&
      this.device.roles?.includes(DeviceRoles.ProductHeatpump)
    );
  }

  private getImageUri({ isStandalone }: RichDevice): string {
    return isStandalone || !this.gatewayHasDevices ? '/assets/img/devices/standalone.png' : '';
  }
}
